import api from '@pray/shared/utils/api';

/**
 * Trigger invalidate transcripts processing
 */
export async function triggerInvalidateTranscripts(artistId: string) {
  const url = `/web/studio/artists/${artistId}/transcripts/invalidate`;
  const response = await api.executePostRequest<undefined>(url, {});

  return response.data;
}
